import { render } from "./Header.vue?vue&type=template&id=1c5c8f7f&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=1c5c8f7f&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/bob-web/bob-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c5c8f7f"]])

export default __exports__